import axios from 'axios';
import tmpLang from './tmpLang';
const base = '/ktdp/v1/';

/** 숫자 앞에 0을 붙여 자릿 수 맞춤 */
Number.prototype.pad = function (size) {
  var s = String(this);
  while (s.length < (size || 2)) { s = "0" + s; }
  return s;
};
/** spec의 특정 key를 필터링 */
Array.prototype.getCol = function(key) { return this.filter(obj => obj.key == key)[0]; }
/** 배열 숫자들의 합계 */
Array.prototype.sum = function () { return this.reduce((a, b) => a + b, 0) };
/** 배열 숫자들을 지정된 비율로 일괄 증가 */
Array.prototype.scale = function (s) { return this.map(a => a * s) };
/** isoTime 을 date, dt:날짜시간 형식으로 일괄 변환 */
Number.prototype.f = function(type) {
  if(type == 'file_size') {
    let result = this;
    if (result >= 1000000) {
      result = (result / 1000000).toFixed(2) + 'MB';
    } else if (result >= 1000) {
      result = (result / 1000).toFixed(2) + 'KB';
    } else {
      result = (result).toFixed(2) + 'B';
    }
    return result.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
  }
  return this;
},
String.prototype.f = function (type) {
  return (
    !this ? '' :
    type == 'tel' ?  (this.length == 11 ? `${this.slice(0, 3)}-${this.slice(3, 7)}-${this.slice(7)}` : `${this.slice(0, 2)}-${this.slice(2, 5)}-${this.slice(5)}`) :
    type == 'registno' ?  `${this.slice(0, 3)}-${this.slice(3, 5)}-${this.slice(5)}` :
    type == 'date' ? `${this.slice(0, 4)}-${this.slice(4, -2)}-${this.slice(-2)}` :
    type == 'tag' ? this.split(',') :
    type == 'datetime-local' ? new Date(this).toLocaleString('sv-SE', { hour12: false }).replace(',', '').slice(0, -3) :
    type == 'tag_exp' ?  this.split(',').map(tag => `#${tag}`).join(' ') :
    type == 'num' ? parseFloat(this).toLocaleString('ko-KR') :
    this
  );
};
String.prototype.test = function (type) {
  if(!this) {
    return '';    
  } else {
    if(type == 'registno') {
      return /^\d{3}-?\d{2}-?\d{5}$/.test(this);
    }
  }

  return this;
};
const sendFormat = (type, value = '') => {
  return type == 'tag' ? value.join(',') :
    (type == 'date' || type == 'tel' || type == 'registno') ? value.replace(/-/g, '') : value;
};
const cache = {};
let reissueing;

export default {
  methods: {
    /** 디바이스 */
    $getDevice() {
      if(/Macintosh/.test(navigator.userAgent) && navigator.maxTouchPoints > 1) {
        return 'IPAD';
      } else if(window.matchMedia('(max-device-width: 768px)').matches || /Mobile|Macintosh/.test(navigator.userAgent)) {
        return 'MOBILE';
      } else {
        return 'WEB';
      }
    },
    async $setCodes(userLang) {
      await this.$store.commit('lang', tmpLang[userLang]);
      cache.codes = (await this.$api('nonauth/selectCodeList', { cateCd: '', userLang })).list;
      if(window.$vm.$refs.content) window.$vm.$refs.content.$forceUpdate();
    },
    async $setFileTypes() {
      const fileTypeList = (await this.$api('nonauth/selectFileTypeList', {})).list;
      cache.fileTypes = [...fileTypeList];
    },
    async $setProdTask() {
      cache.codes = cache.codes.filter(c=>!['PRODUCT','TASK'].includes(c.cateCd))
      .concat((await this.$api('adm/selectProdList', {})).list.map(({prodId:cd,prodNm:cdNm,sort})=>({cateCd:'PRODUCT',cd,cdNm,sort})))
      .concat((await this.$api('adm/selectTaskList', { })).list.map(({taskId:cd,taskNm:cdNm,sort})=>({cateCd:'TASK',cd,cdNm,sort})));
      cache.codes.push({cateCd:'PRODUCT',cd:'',cdNm:this.$t('설정안함'),sort:0});
      cache.codes.push({cateCd:'TASK',cd:'',cdNm:this.$t('설정안함'),sort:0});
      if(window.$vm.$refs.content) window.$vm.$refs.content.$forceUpdate();
    },
    async $rsaTest(arr=[]) {
      // if (location.host=='ktdp.apwisdom.com') return arr;
      const rsa = new ((await import('@/../public/libs/rsa.min.js')).RSAKey)();
      rsa.setPublic('aa60e26021af09dfceb3bc4fc5f8477e5ebe45d5b72074480a00dfaa00f2bfa9e5da046fbcbb44175cb193f31b4f81f921724c53e89a923253ed22a860cbd188f58509c27160e61bdf150f1533a343746880282417a18e4f766e63d7e8a96f8d70143eab5d38bf552e3c57643de95c7817de8a2a811d2f577428514cc785fc8985c98a91e6b9e43e9f7a767aea6e37f015f59deb2c5dfe12a30ccdffdf96e5c99ec8b7cfc9b61e84e2671d53e939b8a5438ba121145b8291101fa9fd23872676560d29a82c14aa0f9e65514d8a8538875fc33310413b054df3ac0c312a8aaa43e4d253dcb95350171fe4b6bb2874d2184f7131265905631d10139d8e7efffe9b', '10001');
      return arr.map(t=>rsa.encrypt(t));
    },
    async $rsaEnc(arr=[]) {
      const { data: { RSAModulus, RSAExponent } } = await this.$api('nonauth/selectRsaKeyPair', {});
      const rsa = new ((await import('@/../public/libs/rsa.min.js')).RSAKey)();
      rsa.setPublic(RSAModulus, RSAExponent);
      return arr.map(t=>rsa.encrypt(t));
    },
    async $unmask(actCd) {
      // return undefined;
      if (!(await this.$alert(`<textarea id=unmask_txt placeholder="${this.$t('해제 사유')}*" maxlength=100 style="width:100%;margin:-15px 0 -22px"></textarea>`, {title:this.$t('마스킹 해제 요청'), confirm:true}))) throw 'error unmask';
      const unmaskReason = document.querySelector('#unmask_txt').value;
      if (unmaskReason) return (await this.$api('cmm/unmask', {unmaskActCd: actCd, unmaskReason: unmaskReason})).data.unmaskKey;
      this.$alert(this.$t('해제 사유')+' 입력값을 확인하세요');
      throw 'error unmask';
    },
    async $matchDocPwd(docs = [], useApi) {
      docs = docs.filter(d => d.pwdExist);
      if (useApi) {
        let times = 0;
        while (times++ < 5) {
          setTimeout(() => document.querySelector('#matchDocPwd input').focus(), 200);
          if (!(await this.$alert(`<table id="matchDocPwd" style="width:100%">${docs.map(d => `<tr><td>${d.docNm}</td><td><input maxlength="100" placeholder="${this.$t('비밀번호')}" class="form-control" type="password"></td></tr>`).join('')}</table>`, { confirm: true, size: 'md', title: this.$t('문서 비밀번호 확인') })))
            throw 'error matchDocPwd';
          const pwds = document.querySelectorAll('#matchDocPwd input');
          const docPwds = docs.map(({ docId }, i) => ({ docId, docPwd: pwds[i].value }));
          const { data } = await this.$api('main/doc/matchDocPwd', { docPwds: docPwds });
          if (Object.values(data).find(p => !p) != undefined) await this.$alert(this.$t('비밀번호를 확인하세요'));
          else return docPwds;
        }
        throw 'error matchDocPwd';
      }
      setTimeout(() => document.querySelector('#matchDocPwd input').focus(), 200);
      if (!(await this.$alert(`<table id="matchDocPwd" style="width:100%">${docs.map(d => `<tr><td>${d.docNm}</td><td><input maxlength="100" placeholder="${this.$t('비밀번호')}" class="form-control" type="password"></td></tr>`).join('')}</table>`, { confirm: true, size: docs.length==1 && !docs[0].docNm ? 'sm' : 'md', title: this.$t('문서 비밀번호 확인') })))
        throw 'error matchDocPwd';
      const pwds = document.querySelectorAll('#matchDocPwd input');
      return docs.map(({ docId }, i) => ({ docId, docPwd: pwds[i].value })); 
    },
    $code(cateCd) {
      return cache.codes.filter(c => !cateCd || c.cateCd == cateCd).sort((a, b) => a.sort - b.sort).map(c => ({ text: c.cdNm, value: c.cd, icon: c.cdIcon, cdClass: c.cdClass }));
    },
    $getFileType(fileKey) {
      const fileTypes = cache.fileTypes.filter(obj => obj.extensions.includes(fileKey.toLowerCase()));
      return fileTypes ? fileTypes[0] : null;
    },
    $iconUrl(fileKey) {
      const fileType = this.$getFileType(fileKey);
      return fileType ? fileType.iconUrl : '/img/file.svg';
    },
    $fileType(fileKey) {
      const fileType = this.$getFileType(fileKey);
      return fileType ? fileType.fileType : '';
    },
    async $tree(api, params) {
    // async $tree(api, params, resetCache) {
      // if (!resetCache && cache[api]) return cache[api];
      // return cache[api] = (await this.$api(api, params)).list;
      return (await this.$api(api, params)).list;
    },
    /** js 라이브러리를 필요한 시점에 동적으로 로딩 */
    $loadScript(src) {
      return new Promise((resolve, reject) => {
        if (document.querySelector(`script[src = "${src}"]`)) return resolve();
        const el = document.createElement('script');
        el.type = 'text/javascript';
        el.async = true;
        el.src = src;
        el.addEventListener('load', resolve);
        el.addEventListener('error', reject);
        document.head.appendChild(el);
      });
    },
    $loadXlsx(file, encoding, output = 'json') {
      return new Promise(async (resolve) => {
        await this.$loadScript('/libs/xlsx.0.15.5.js');
        const ret = {}, reader = new FileReader();
        reader.onload = () => {
          const workBook = window.XLSX.read(reader.result, { raw: true, type: 'string' });
          workBook.SheetNames.forEach(sheetName => ret[sheetName] = window.XLSX.utils['sheet_to_' + output](workBook.Sheets[sheetName]));
          resolve(ret);
        };
        reader[encoding ? 'readAsText' : 'readAsBinaryString'](file, encoding);
      });
    },
    async $downloadAuth(url, filename) {
      const blob = await (await fetch(url, { headers: { 'X-AUTH-TOKEN': this.$store.state.user.accessToken } })).blob();
      const blobUrl = URL.createObjectURL(blob);
      const link = document.createElement('a');
      link.href = blobUrl;
      link.download = filename;
      link.click();
      URL.revokeObjectURL(blobUrl);
    },
    $download(href, download) {
      var a = document.createElement('a');
      a.href = href;
      a.download = download;
      a.click();
    },
    /** 다운로드 url 생성 */
    $url(url, down) {
      return `${base}download/${url}${down && down === true ? '?down=Y' : ''}`
    },
    $downloadMulti(url, filename) {
      return `${base}downloadMulti?url=${url.join(',')}${filename ? `&filename=${encodeURIComponent(filename)}` : ''}`;
    },
    /** 다국어 변환 (세팅값에 따라 api 수신 후 로컬에 저장된 개체로 변환) */
    $t(txt, params) {
      if (!txt) return txt;
      // 다국어 사전 수집용
      // if (!this.$store.state.tmpT[txt]) this.$store.commit('tmpT', txt);
      txt = this.$store.state.lang[txt] || txt;
      // $t("$와 $님께",["A","B"]) => "A와 B님께" 로 치환합니다.
      if (Array.isArray(params)) for (const p of params) txt = txt.replace('$', p);
      return txt;
    },
    /** 라우팅 전환 */
    $go(path) {
      if (!document.startViewTransition) document.startViewTransition = f => f();
      document.startViewTransition(() => {
        if (!isNaN(path)) this.$router.go(path);
        else if (path == this.$route.fullPath)
          this.$router.push('/redirect?target=' + path);
        else this.$router.push(path);
      });
    },
    /** 공통 alert, confirm 처리 (Promise) */
    $alert(body, options = {}) {
      this.$bvModal.hide("mixin-modal");
      if (!body) return;
      body = this.$createElement('div', { domProps: { innerHTML: body } });
      // , headerBgVariant: 'info', headerTextVariant: 'light'
      const defaults = { id: "mixin-modal", confirm: false, title: options.confirm ? this.$t('확인') : this.$t('알림'), okTitle: this.$t('확인'), cancelTitle: this.$t('취소'), size: 'sm', buttonSize: 'sm', centered: true, hideHeaderClose: false };
      return this.$bvModal[options.confirm ? 'msgBoxConfirm' : 'msgBoxOk']([body], {
        ...defaults, ...options,
        noCloseOnBackdrop: true, scrollable: true
      })
    },
    /** 텍스트파일을 블롭변환하여 다운로드하는 공통함수 */
    $saveAs(url, filename) {
      const downloadLink = document.querySelector('a[download]') || document.createElement("a");
      downloadLink.download = filename;
      downloadLink.href = url.arrayBuffer ? window.URL.createObjectURL(url) : url;
      downloadLink.style.display = "none";
      document.body.appendChild(downloadLink);
      downloadLink.click();
    },
    /** 공통 toast 처리 */
    $toast(txt, options = {}) {
      const defaults = { variant: 'info', autoHideDelay: 2500, appendToast: true, headerClass: 'd-none',  toaster: 'b-toaster-bottom-center', maxToast: 1 };
      options = Object.assign({}, defaults, options);
      if(options.maxToast) {
        const toastEls = document.querySelectorAll('.b-toaster-slot > div');
        toastEls.forEach((el, idx) => {
          if(options.appendToast === true) {
            if(idx <= toastEls.length - options.maxToast) { el.remove(); }
          } else {
            if(idx >= options.maxToast - 1) { el.remove(); }
          }
        });
      }

      this.$bvToast.toast(txt, options);
    },
    /** 공통 api 연동 처리 (Promise) */
    async $api(url, data, opt = {}) {
      let reissueWaitTimes = 0;
      if (url != 'reissue') while(reissueing) {
        await this.$delay(100);
        if ( reissueWaitTimes++>20 || !this.$store.state.user.accessToken ) throw 'reissueing fail: '+url;
      }
      let { headers, errors, onUploadProgress, onDownloadProgress, retry, defaultProgress } = Object.assign({ headers: {}, errors: { 403: this.$t('해당 작업의 권한이 없습니다.') } }, opt);
      const { accessToken, refreshToken } = this.$store.state.user;
      const custId = this.$store.state.user.custId ? this.$store.state.user.custId : (data && data.custId) ? data.custId : '';
      if (accessToken) headers['X-AUTH-TOKEN'] = accessToken;
      if (!onUploadProgress) onUploadProgress = ({ total, loaded }) => this.$store.commit('progress', { progress: Math.round(loaded * 100 / total) });
      if (!onDownloadProgress) onDownloadProgress = ({ total, loaded }) => this.$store.commit('progress', { progress: Math.max(100, Math.round(loaded * 100 / (total || 20000))) });
      let method = data ? 'post' : 'get';
      
      const progTimer = setTimeout(() => this.$store.commit('progress', { progress: defaultProgress || 10 }), 500);
      const { data: res } = await axios({ method, url: /^(http|\/)/.test(url) ? url : base + url, data, headers, onUploadProgress, onDownloadProgress }).catch(async (e) => {
        clearTimeout(progTimer);
        this.$store.commit('progress', { progress: 100 });
        if (e.response) {
          const { status, data:res } = e.response;
          if (status == 401 && errors[401] == undefined) {
            if (res && [-1007].includes(res.code)) { // Access token 만료
              if (!retry) {
                if (reissueing) {
                  while(reissueing) {
                    await this.$delay(100);
                    if ( reissueWaitTimes++>20 || !this.$store.state.user.accessToken ) throw 'reissueing fail: '+url;
                  }
                  opt.retry = true;
                  return { data: await this.$api(url, data, opt) };
                }
                reissueing = true;
                try {
                  const reissue = await this.$api('reissue', { accessToken, refreshToken, custId }, { retry: true });
                  if (reissue.success) {
                    await this.$store.commit('user', Object.assign(reissue.data.user, { accessToken: reissue.data.accessToken, refreshToken: reissue.data.refreshToken }));
                    reissueing = false;
                    opt.retry = true;
                    return { data: await this.$api(url, data, opt) };
                  }
                } catch (e) { console.log('reissue error', e) }
                reissueing = false;
              }
            } else await this.$alert(res.msg);
            this.$store.commit('user');
          }
          else if (errors[status] !== '') await this.$alert(errors[status] || res.msg || e + '');
        }
        else this.$alert(this.$t('네트워크 연결을 확인하세요.'));
        throw e;
      });
      clearTimeout(progTimer);
      this.$store.commit('progress', { progress: 100 });
      if (!res || (res.success === false && url.slice(-4) == 'List' && !res.list)) {
        if(res.msg) this.$alert(res.msg);
        throw res.msg;
      }
      return res;
    },
    /** 전송시에만 값을 바꿔보내는 경우의 처리 */
    $formSendMaper(form, spec) {
      const trans = {};
      for (const { key, type, sendMaper } of spec) if (form[key]!=undefined) trans[key] = sendMaper ? sendMaper(form[key]) : sendFormat(type, form[key]);
      return trans;
    },
    /** 딜레이 (Promise) */
    $delay(timeout) {
      return new Promise(resolve => setTimeout(resolve, timeout));
    },
    $json2formdata(data, key='jsonFile', name='jsonFile', type='application/json') {
      const formData = new FormData();
      formData.headers = { 'Content-Type': 'multipart/form-data' };
      if (typeof data == 'string') formData.append(key, new Blob([data], { type }), name);
      else formData.append(key, new Blob([JSON.stringify(data)], { type }), name);
      return formData;
    },
    $setCheckEvent(allEl, itemEls) {
      if(allEl && itemEls) {
        let unchecked = Array.from(itemEls).filter(itemEl => !itemEl.checked).length;
        allEl.checked = unchecked == 0 ? true : false;

        // 전체 체크박스 선택시
        allEl.addEventListener('click', (evt) => {
          itemEls.forEach(itemEl => {
            itemEl.checked = evt.target.checked
            itemEl.dispatchEvent(new Event('change'));
          });
        });

        // 항목 체크박스 선택시
        itemEls.forEach(itemEl => {
          itemEl.addEventListener('click', () => {
            let unchecked = Array.from(itemEls).filter(itemEl => !itemEl.checked).length;
            allEl.checked = unchecked == 0 ? true : false;
          });
        });
      }
    },
    $reduceScreen() {
      document.querySelector('.app-main').classList.add('mw-1320px');
    },
    $isEmpty(value) {
      return value === undefined 
        || value === null 
        || (typeof value === 'string' && value.trim() === '') 
        || (Array.isArray(value) && value.length === 0) 
        || (typeof value === 'object' && !Array.isArray(value) && Object.keys(value).length === 0);
    },
    $isNotEmpty(value) {
      return !this.$isEmpty(value);
    },
    $nvl(value, defaultValue) {
      return this.$isEmpty(value) ? defaultValue : value;
    },
    $isInteger(num) {
      if(this.$isEmpty(num)) {
        return false;
      } else {
        return Number.isInteger(Number(num));
      }
    },
    $unescapeHtml(value) {
      if (this.$isNotEmpty(value) && typeof value === 'string') {
        return value
          .replace(/&amp;/g, '&')
          .replace(/&lt;/g, '<')
          .replace(/&gt;/g, '>')
          .replace(/&quot;/g, '"')
          .replace(/&apos;/g, "'");
      }
      return value;
    },
    $today() {
      const date = new Date();
      const year = date.getFullYear();
      const month = String(date.getMonth() + 1).padStart(2, '0');
      const day = String(date.getDate()).padStart(2, '0');
      return `${year}-${month}-${day}`;
    },
  }
}